import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Icon from '../../Icon'

import styles from './style.module.scss'

/**
 * Zähler-Kachel für die Startseiten: eine Beschriftung, eine Zahl, ein Ziel.
 *
 * Die ganze Kachel ist der Verweis — nicht ein kleiner „Volle Liste"-Text in
 * der Ecke. Wer die Zahl sieht, will die Liste dahinter; alles andere wäre ein
 * Klickziel von 80 px in einer 240 px breiten Fläche.
 *
 * **Sie trägt seit 26.08.2026 dieselbe Gestalt wie die Kacheln der
 * „Allgemeinen Information" darüber**: dasselbe Blaugrau, dieselbe Rundung,
 * mittig gesetzt, Zahl unter der Beschriftung. Vorher standen auf einer Seite
 * zwei Sorten Kacheln untereinander — weiße mit linksbündigem Text unter
 * blaugrauen mit mittigem —, und die untere Reihe sah aus, als gehöre sie zu
 * einer anderen Anwendung.
 */
export default function CounterWidget(props) {
	/*
	 * Handlungsbedarf faerbt nur, wenn es welchen gibt: Eine dauerhaft orange
	 * Kachel mit einer 0 darin waere ein Alarm ohne Anlass — und nach der
	 * zweiten Woche sieht niemand mehr hin.
	 */
	const dringend = props.attention && props.count > 0

	return (
		<Link className={clsx(styles.root, dringend && styles.attention, props.className)} to={props.to}>
			<span className={styles.label}>{props.label}</span>
			<span className={styles.count}>{props.count}</span>
			{!!props.hint && <span className={styles.hint}>{props.hint}</span>}
			<Icon
				className={styles.arrow}
				name="arrow"
				color={dringend ? '#EF8400' : '#008B9C'}
				size={{ w: 12, h: 12 }}
			/>
		</Link>
	)
}

CounterWidget.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string.isRequired,
	count: PropTypes.number,
	to: PropTypes.string.isRequired,
	// Ein Satz darunter: wozu diese Zahl auffordert ("wartet auf Abnahme").
	hint: PropTypes.string,
	// Zahlen, bei denen jemand handeln muss, statt sie nur zur Kenntnis zu
	// nehmen. Wirkt erst ab 1 (siehe oben).
	attention: PropTypes.bool
}

CounterWidget.defaultProps = {
	count: 0,
	attention: false
}
